import React from "react";

export const ListDivider = () => null;
